<template>
  <div>
    <div v-if="loading" class="pt-4 mt-2">
      <div class="card card-shadow card-rounded border-0 mb-4">
        <div class="card-body py-5 text-center">
          <spinner></spinner>
        </div>
      </div>
    </div>
    <div v-else>
      <SurveyCompleted v-if="done" @on-survey-completed="$emit('on-survey-completed')"/>
      <QuestionGroup v-else :questions="questions" :title="description" @submit="submit" @on-survey-skipped="$emit('on-survey-completed')"/>
    </div>
  </div>
</template>
<script>
import QuestionGroup from '@shared/components/survey/QuestionGroup'
import store from '@shared/store'
import SurveyCompleted from '@shared/components/survey/SurveyCompleted'

export default {
  name: 'Survey',
  components: { SurveyCompleted, QuestionGroup },
  props: ['trigger'],
  data() {
    return {
      loading: true,
      done: false,
      questions: [],
      headers: [],
      description: ''
    }
  },
  created() {
    const pin = store.state.currentUser.pin
    const trigger = this.trigger
    this.$http.get(`/api/survey/${pin}/start/${trigger}`).then((response) => {
      if (!response.data) {
        this.$emit('on-survey-completed')
      } else {
        this.headers = response.headers
        this.questions = response.data.questions
        this.description = response.data.description
      }
      this.loading = false
    })
  },
  methods: {
    submit(answers) {
      const pin = store.state.currentUser.pin
      this.loading = true
      this.$http.post(`/api/survey/${pin}/next`, { answers }, { headers: this.headers }).finally(() => {
        this.loading = false
        this.done = true
      })
    }
  }
}
</script>
